import React, { useState, useEffect } from "react";
import "./index.css";

const Footer = () => {
  const [formData, setFormData] = useState({
    first: "",
    last: "",
    number: "",
    email: "",
    message: "",
    agreed: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [modal, setModal] = useState({ show: false, type: 'success', message: '' });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const showModal = (type, message) => {
    setModal({ show: true, type, message });
  };

  const closeModal = () => {
    setModal({ show: false, type: 'success', message: '' });
  };

  useEffect(() => {
    if (modal.show) {
      document.body.style.overflow = 'hidden';
      const timer = setTimeout(() => {
        closeModal();
      }, 5000); // Auto close after 5 seconds
      return () => {
        clearTimeout(timer);
        document.body.style.overflow = '';
      };
    } else {
      document.body.style.overflow = '';
    }
  }, [modal.show]);

  function submit(e) {
    e.preventDefault();
    
    if (!formData.agreed) {
      showModal('error', 'Please agree to the Terms and Conditions');
      return;
    }

    if (!validateEmail(formData.email)) {
      showModal('error', 'Please enter a valid email address');
      return;
    }

    setIsSubmitting(true);

    // Simulate form submission
    setTimeout(() => {
      showModal('success', 'Thank You For Contacting Us! We will get back to you soon.');
      setFormData({
        first: "",
        last: "",
        number: "",
        email: "",
        message: "",
        agreed: false
      });
      setIsSubmitting(false);
    }, 500);
  }

  return (
    <>
      {/* Modal Popup */}
      {modal.show && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className={`modal-popup modal-${modal.type}`} onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal} aria-label="Close modal">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
            <div className="modal-content">
              <div className="modal-icon">
                {modal.type === 'success' ? (
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                  </svg>
                ) : (
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                  </svg>
                )}
              </div>
              <h3 className="modal-title">{modal.type === 'success' ? 'Success!' : 'Error'}</h3>
              <p className="modal-message">{modal.message}</p>
              <button className="modal-button" onClick={closeModal}>
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      <section className="contactus-section" id="footer">
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-10 mx-auto">
              <div className="row">
                <div className="contact-leftside col-12 col-lg-5">
                  <div className="call">
                    <h1>
                      Don't Be Shy,<br />
                      Give Us A Call
                    </h1>
                  </div>
                  <div className="contact-info">
                    <div className="contact-item">
                      <h5>Contact Person</h5>
                      <p>Mohammed Abid</p>
                    </div>
                    <div className="contact-item">
                      <h5>Phone</h5>
                      <p>07707711092</p>
                    </div>
                    <div className="contact-item">
                      <h5>Email</h5>
                      <p>bsks@besafekeepsafe.co.uk</p>
                    </div>
                  </div>
                </div>

                <div className="contact-rightside col-12 col-lg-7">
                  <form onSubmit={submit}>
                  <div className="row">
                    <div className="col-12 col-lg-6 contact-input-field">
                      <input
                        type="text"
                        name="first"
                        value={formData.first}
                        onChange={handleChange}
                        placeholder="First Name"
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="col-12 col-lg-6 contact-input-field">
                      <input
                        type="text"
                        name="last"
                        value={formData.last}
                        onChange={handleChange}
                        placeholder="Last Name"
                        className="form-control"
                        required
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12 col-lg-6 contact-input-field">
                      <input
                        type="tel"
                        name="number"
                        value={formData.number}
                        onChange={handleChange}
                        placeholder="Phone Number"
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="col-12 col-lg-6 contact-input-field">
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Email Address"
                        className="form-control"
                        required
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12 contact-input-field">
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        placeholder="Tell us about your health & safety needs..."
                        className="form-control"
                        rows="4"
                        required
                      ></textarea>
                    </div>
                  </div>

                  <div className="form-checkbox-style">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="agreed"
                      checked={formData.agreed}
                      onChange={handleChange}
                      id="termsCheckbox"
                    />
                    <label htmlFor="termsCheckbox" className="main-hero-para">
                      I agree to the Terms and Conditions
                    </label>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-style w-100"
                    id="contact-submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Sending...' : 'Send Message'}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default Footer;
